/* eslint-disable sort-imports */
import '@config';
import '@styles/theme';
import 'airbnb-browser-shims';
import BackgroundWrap from './blocks/backgroundWrap';
import CareersLobby from './blocks/careersLobby';
import FormAndContent from './blocks/formAndContent';
import MegaMenu from './blocks/megaMenu.js';
import Accordion from './components/accordion';
import AnnouncementBar from './components/announcementBar';
import Example from './components/example';
import FormMarketo from './components/formMarketo';
import LottieAnimation from './components/lottieAnimation';
import Map from './components/map';
import NavFooter from './components/navFooter.js';
import Range from './components/range';
import Router from './components/router';
import Video from './components/video';
import EqualizeHeight from './directives/equalizeHeight';
import Filter from './directives/filter';
import Root from './directives/root';
import './images';
import './vendor/bootstrap.js'; import './vendor/customChoices.js'; import './vendor/fontawesome.js';

import AnnouncementBarBlock from './blocks/announcementBarBlock';
import ContentMenu from './blocks/contentMenu';
import DevZoneForms from './blocks/devZoneForms.js';
import Documentation from './blocks/documentation.js';
import ImageSlider from './blocks/imageSlider';
import ModelExplorer from './blocks/modelExplorer';
import NewsLobby from './blocks/newsLobby';
import PartnersLobby from './blocks/partnersLobby';
import Platforms from './blocks/platforms';
import PostLobby from './blocks/postLobby';
import SoftwareKeyComponents from './blocks/softwareKeyComponents';
import SphinxArchiveInner from './blocks/sphinxArchiveInner.js';
import SupportLobby from './blocks/supportLobby.js';
import SwDownloads from './blocks/swDownloads.js';
import Tabs from './blocks/tabs.js';
import Testimonials from './blocks/testimonials';
import UserJourneyPicker from './blocks/userJourneyPicker.js';
import VideoInner from './blocks/videoInner';
import AccordionWithMedia from './components/accordionWithMedia';
import CardLink from './components/cardLink';
import ModalNotification from './components/modalNotification';
import Search from './components/search';
import HeaderLogin from './components/headerLogin';
import SupportInnerVideo from './components/supportInnerVideo.js';
import ContactCustomerSupport from './pages/contactCustomerSupport.js';
import SearchPage from './pages/searchPage';
import deviceDetailsTabs from "./blocks/devicesTabs";
import 'lightbox2/dist/css/lightbox.css';
import lightbox from 'lightbox2';

$(document).on('ready', () => {
  const router = new Router([
    new Example(),
    new Root(),

    // Preserve order
    new AnnouncementBar(),
    new NavFooter(),
    new VideoInner(),
    new SoftwareKeyComponents(),

    // End preserve order
    new Accordion(),
    new AccordionWithMedia(),
    new FormMarketo(),
    new LottieAnimation(),
    new Video(),
    new BackgroundWrap(),
    new EqualizeHeight(),
    new Filter(),
    new MegaMenu(),
    new CareersLobby(),
    new FormAndContent(),
    new Map(),
    new ImageSlider(),
    new Testimonials(),
    new Range(),
    new Platforms(),
    new PostLobby(),
    new SupportLobby(),
    new NewsLobby(),
    new CardLink(),
    new PartnersLobby(),
    new ContentMenu(),
    new AnnouncementBarBlock(),
    new ModalNotification(),
    new Search(),
    new HeaderLogin(),
    new ModelExplorer(),

    new SearchPage(),
    new ContactCustomerSupport(),
    new UserJourneyPicker(),
    new SupportInnerVideo(),
    new Documentation(),
    new SwDownloads(),
    new DevZoneForms(),
    new SphinxArchiveInner(),
    new Tabs(),
    new deviceDetailsTabs(),

    lightbox.option({
      'resizeDuration': 200,
      'wrapAround': true
    })


  ]);

  router.bootstrap();
});
